import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Hot_tar() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>      זפת חם </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Bituminoussheets">   יריעות ביטומניות</Link>/{" "}
    <Link to="/Hot_tar">    זפת חם  </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
זפת חם, הינו בסיס לאיטום גגות. אוטמים מקצועיים רבים, מורחים על הגג שכבה של זפת שעבר הרתחה על אש, ורק אחר כך מצפים את הגג ביריעות איטום. השוק מוצף בסוגים שונים של פחיות זפת. את תוכן פחית או דלי הזפת, מרוקנים לתוך מיכל עגול גדול מפח. את מיכל הפח מחממים על אש. לאחר מכן, מורחים את הזפת החמה על הגג, או המשטח אותו רוצים לאטום.   </h2>
    <div className="content-row">

      <div className="image-box">
        <img src="/images/62.jpg" alt="roof" />
      </div>
      <div className="text-box">



    <h2 className="main-title">
שימושים מתקופות קדומות בחומר הזפת:



    </h2>
        <p>         השימוש ביריעות איטום, הוא פיתוח של הדור שלנו. אולם, בחומר הזפת, השתמשו כבר בתקופות קדומות, להגנה מפני רטיבות ומים. השימוש היה כבר בתקופת המבול. כאשר נוח בנה את התיבה, הוא ציפה אותה מבפנים ומבחוץ בזפת. גם כאשר הכניסו את משה רבינו לתיבה כאשר נולד, ציפו את התיבה מבחוץ בזפת, לבל יחדרו אליה המים. לאורך תקופת המקרא, המשנה, התלמוד ושאר התקופות, מרחו את הגגות בזפת, כדי להגן מפני רטיבות.        </p>



      </div>




    </div>

    <h2 className="main-title">
היכן מחממים את הזפת?


    </h2>

    <div className="bottom-text">
      <p> עד לעשור האחרון, היה פחות מודעות לסכנה שבחימום זפת בחצר, או ברחוב. לכן, היה ניתן לראות פועלים מחממים זפת ברחוב או בחנייה של הבניין, ומעלים את הזפת החמה אל גג הבניין באמצעות חבל. אולם, בשנים האחרונות יש יותר מודעות לסכנות העלולות להיגרם לעוברים ושבים. לכן, על מנת לגרום נזק לעוברים ושבים, חברות איטום רבות, יעדיפו לחמם את הזפת על הגג. </p>

    <h2 className="main-title">
חיפוי קירות באמצעות זפת חם 


    </h2>

      <p>בניינים רבים במדינה, נבנו מחומרים לא איכותיים מספיק. לכן, קירות רבים של בניינים, לא חדירים מספיק מפני רטיבות ויש צורך לבצע שיקום מבנים. לכן, יש צורך לצפות את הקירות הללו בשכבת זפת חם. חומר הזפת, הינו חומר יעיל מאוד, ונוח מאוד למריחה על קירות. מומלץ לצפות קירות בזפת חם, גם אם מעל הקירות שמים כציפוי יריעות ביטומניות דקות. במבנים בעלי קירות דקים במיוחד, כדאי לצפות את הקיר גם מבפנים, וגם מבחוץ.</p>

    <h2 className="main-title">
כללי בטיחות בעת ציפוי המבנה בזפת:



    </h2>

      <p> חומר הזפת אינו חומר רעיל לנשימה, אך אינו חומר בריא. ריח הזפת החם, אינו ריח נעים. לכן, מומלץ כאשר מצפים את המבנה מבחוץ, לסגור את כל החלונות של הבניין. כאשר ציפוי הגג בזפת נעשה ביום קיץ, ניתן להדליק במשך השעות הללו, את המזגן. אולם, אם מצפים את קירות הבניין מבפנים, מומלץ לא לשהות במבנה ביום זה. מומלץ לעובדים לקחת חופש ליום אחד. כמובן, כאשר מצפים מבפנים בזפת בניין עם ילדים קטנים, מומלץ לפנות את המשפחות למשך היום בו נעשית פעולת ציפוי הקירות בזפת.
</p>


    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Types_of_bituminous_sheets" className="link-right" >  סוגי יריעות ביטומניות </Link>
  <Link to="/Working_at_Height" className="link-left" >  עבודה בגובה  </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

